import { render, staticRenderFns } from "./ProductFileStatusBadge.vue?vue&type=template&id=0e764b7a&scoped=true&"
import script from "./ProductFileStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ProductFileStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e764b7a",
  null
  
)

export default component.exports